import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import { vuetifyTheme } from '@/utils/theme';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        ...vuetifyTheme
      }
    }
  }
});
